"use strict";const t=require("styled-components").css`
    position: relative;
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;

    > img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        object-fit: cover;
    }

    .aspect-ratio {
        width: 100%;
        height: 0;
        padding-top: ${({ratio:t})=>{const[i,e]=(t||"1:1").split(":");return`${100/(parseInt(i,10)||1)*(parseInt(e,10)||1)}%`}};
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
